/*
 * Module for the Checks (Vendor) job criteria page
 */
rs.module("content/jobs/criteria/checksvendor",

    ["common/select-helper", "common/visibility"],

    function (selectHelper, visibility) {

        // Initialize the page
        function initialize(jsSelectors, modes, outputTypes, rangeTypes, defaultPrinter, defaultStartingCheckNumber, backendUrls) {
            var criteria = $.js(jsSelectors.criteria);

            var modeLoadingSpinner = criteria.js(jsSelectors.modeLoadingSpinner);
            var outputTypeLoadingSpinner = criteria.js(jsSelectors.outputTypeLoadingSpinner);

            var modeRadioContainer = criteria.js(jsSelectors.modeRadioContainer);
            var outputTypeSelect = criteria.js(jsSelectors.outputTypeSelect);
            var gridContent = criteria.js(jsSelectors.gridContent);
            var startingCheckNumberInput = criteria.js(jsSelectors.startingCheckNumberInput);
            var useExistingCheckNumberContainer = criteria.js(jsSelectors.useExistingCheckNumberContainer);
            var useExistingCheckNumberCheckBox = criteria.js(jsSelectors.useExistingCheckNumberCheckBox);
            var rangeContainer = criteria.js(jsSelectors.rangeContainer);
            var rangeTypeRadioContainer = criteria.js(jsSelectors.rangeTypeRadioContainer);
            var checkNumberRangeContainer = criteria.js(jsSelectors.checkNumberRangeContainer);
            var printerSelect = criteria.js(jsSelectors.printerSelect);
            var producePositivePayFileContainer = criteria.js(jsSelectors.producePositivePayFileContainer);
            
            // Get Select Helpers for selects where we're updating options and properties
            var printerSelectHelper = selectHelper.getHelper(printerSelect);

            // Register click event for mode radio buttons 
            modeRadioContainer.find("input").on("click", () => updateContentDisplay(jsSelectors.modeRadioContainer)); 

            // Register outputTypeSelect changed event
            outputTypeSelect.change(() => updateContentDisplay(jsSelectors.outputTypeSelect));

            // Register useExistingCheckNumberCheckBox changed event
            useExistingCheckNumberCheckBox.change(function () {
                enableDisableStartingCheckNumber();
            });

            // Register click event for range type radio buttons 
            rangeTypeRadioContainer.find("input").on("click", () => updateRangeDisplay());

            // Handle dynamic display of content
            function updateContentDisplay(jsSelector) {

                // get selected mode
                var selectedMode = modeRadioContainer.find("input:checked").val();

                // determine what has changed so we can react accordingly
                if (jsSelector == jsSelectors.modeRadioContainer) {
                    modeLoadingSpinner.show();                    
                }
                else if (jsSelector == jsSelectors.outputTypeSelect) {
                    outputTypeLoadingSpinner.show();
                }

                // get selected output type
                var selectedOutputType = outputTypeSelect.val();

                // display appropriate partial view (grid) based on selected mode 
                if (selectedMode == modes.create) {
                    _updateGridContentFrom(
                        backendUrls.getGridPartialView,
                        {
                            mode: selectedMode,
                            outputType: selectedOutputType
                        });
                }
                else if (selectedMode == modes.recreate) {

                    _updateGridContentFrom(
                        backendUrls.getGridPartialView,
                        {
                            mode: selectedMode,
                            outputType: selectedOutputType
                        });
                }
                else {
                    _updateGridContentFrom(
                        backendUrls.getGridPartialView,
                        {
                            mode: selectedMode,
                            outputType: selectedOutputType
                        });
                }

                // enable/disable the remaining child controls beneath the partial view (grid)
                updateChildControls(selectedMode, selectedOutputType);
            }

            // Update grid content (partial views) from a url with parameters 
            function _updateGridContentFrom(url, parameters) {

                $.get(url, parameters)
                    .done(function (html) {
                        gridContent.html(html);
                    })
                    .always(function () {
                        modeLoadingSpinner.hide();
                        outputTypeLoadingSpinner.hide();
                    });
            }

            // enable/disable the remaining child controls, beneath the partial view (grid), based on combos of mode and output type
            function updateChildControls(selectedMode, selectedOutputType) {

                visibility.setVisible(useExistingCheckNumberContainer, selectedMode == modes.recreate);
                visibility.setVisible(rangeContainer, selectedMode == modes.recreate);
                visibility.setVisible(producePositivePayFileContainer, selectedMode != modes.recreate);

                if (selectedMode == modes.recreate) {
                    updateRangeDisplay();
                }

                if (selectedOutputType != outputTypes.print) {
                    printerSelectHelper.setDisabled(true);
                    printerSelectHelper.setValue(defaultPrinter);          
                }
                else {
                    printerSelectHelper.setDisabled(false);
                }
            }

            // Handle enabling/disabling of useExistingCheckNumberCheckBox
            function enableDisableStartingCheckNumber() {

                if (useExistingCheckNumberCheckBox.is(":checked")) {
                    startingCheckNumberInput.prop("disabled", true).clearErrors().val(defaultStartingCheckNumber);
                }
                else {
                    startingCheckNumberInput.prop("disabled", false);
                }
            }

            // Handle dynamic display of range fields
            function updateRangeDisplay() {

                // get selected range type
                var selectedRangeType = rangeTypeRadioContainer.find("input:checked").val();

                visibility.setVisible(checkNumberRangeContainer, selectedRangeType == rangeTypes.checkNumber);
            }
        }

        var exports = {
            initialize: initialize,
        };

        return exports;
    }
);